export function Backlight({ blur = 40, children, className }) {
  return (
    <div className={`relative ${className}`}>
      {/* 
        Dynamic CSS Glow Layer:
        We duplicate the content and apply standard CSS filters.
        This provides the exact same visual effect as the SVG filter, 
        but is 100% supported on all mobile devices.
      */}
      <div 
        className="absolute inset-0 z-0 pointer-events-none select-none mix-blend-screen"
        style={{
          filter: `blur(${blur}px) saturate(400%)`,
          transform: 'scale(1.02) translateY(2%)',
          opacity: 0.9,
        }}
        aria-hidden="true"
      >
        {children}
      </div>
      
      {/* Inner Content wrapper */}
      <div className="relative z-10 w-full h-full">
        {children}
      </div>
    </div>
  );
}
